import React, { useState, useEffect } from "react";
import useFetchPost from "../hooks/useFetchPost";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import { toast, Bounce } from "react-toastify";

const RestoreModal = ({ data, setApiRun }) => {
	const [newFreeTrialDate, setNewFreeTrialDate] = useState(null);
	const { fetchPostData, error } = useFetchPost();
	useEffect(() => {
		if (data && data.canceled_date) {
			setNewFreeTrialDate(new Date(data.canceled_date * 1000));
		}
	}, [data]);

	const handleClose = () => {
		const restoreModal = document.getElementById("restoreModal");
		restoreModal.classList.remove("show");
		restoreModal.style.display = "none";
	};
	//form validation with data set
	const handleNewFreeTrailDateChange = (date) => {
		const newdate = new Date(date);
		const day = String(newdate.getDate()).padStart(2, "0");
		const month = String(newdate.getMonth() + 1).padStart(2, "0");
		const year = newdate.getFullYear();

		const formattedDate = `${month}-${day}-${year}`;

		setNewFreeTrialDate(new Date(newdate));
		//new Date("2024-04-25").getTime()
	};

	// Function to handle data submission
	const handleSubmit = async () => {
		// Submit form data

		const postData = {
			studio_id: data && data.customer_id,
			startDate: newFreeTrialDate,
		};

		let crmStagingUrl = process.env.REACT_APP_CRM + "/muvi5/restore";
		let responseData;
		try {
			responseData = await fetchPostData(crmStagingUrl, postData);
			//console.log("Response:", responseData);
		} catch (error) {
			console.error("Error:", error);
		}
		if (responseData && responseData.status == "OK") {
			setApiRun(true);
			// Reset form
			setNewFreeTrialDate(new Date());

			toast.success(responseData.msg, {
				position: "top-right",
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "light",
				transition: Bounce,
			});
		} else {
			const errorMessage = responseData && responseData.msg ? responseData.msg : "An error occurred";

			toast.error(errorMessage, {
				position: "top-right",
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "light",
				transition: Bounce,
			});
			console.warn("Something went wrong .in change to muvi ownership");
		}

		// Close the modal
		const restoreModal = document.getElementById("restoreModal");
		restoreModal.classList.remove("show");
		restoreModal.style.display = "none";
	};

	return (
		<div className="modal fade" id="restoreModal" tabindex="-1" role="dialog" aria-labelledby="restoreModalLabel">
			<div className="modal-dialog" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<button
							type="button"
							className="close"
							data-dismiss="modal"
							aria-label="Close"
							onClick={handleClose}
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 className="modal-title" id="restoreModalLabel">
							Extend Trial Period
						</h4>
					</div>
					<div className="modal-body">
						<form>
							<div class="form-group">
								<label for="recipient-name" className="control-label">
									Company
								</label>
								<input
									type="text"
									className="form-control"
									disabled
									value={data && data.company_name}
								/>
							</div>
							<div class="form-group">
								<label for="recipient-name" className="control-label">
									Trial Period
								</label>
								<DatePicker
									selected={newFreeTrialDate}
									dateFormat="dd-MM-yyyy" // You can set the date format here
									placeholderText="Select date"
									onChange={handleNewFreeTrailDateChange}
									//minDate={new Date()}
									yearDropdownItemNumber={15}
								/>
							</div>
						</form>
					</div>
					<div className="modal-footer">
						<span type="button" className="btn btn-blue" data-dismiss="modal" onClick={handleClose}>
							Close
						</span>
						<span type="button" className="btn btn-primary" data-dismiss="modal" onClick={handleSubmit}>
							Submit
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default RestoreModal;



// WEBPACK FOOTER //
// ./src/components/crm/modals/RestoreModal.jsx